module.exports = __webpack_public_path__ + "img/default _user.ec111d5a.png";